// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"U1-z"};